import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

export function createAgonI18n(locale: string) {
  return createI18n({
    locale: locale || 'en',
    fallbackLocale: 'en',
    messages: messages,
  });
}
